import { render, staticRenderFns } from "./CommitteeMembersCreate.vue?vue&type=template&id=6ed33b68"
import script from "./CommitteeMembersCreate.vue?vue&type=script&lang=js"
export * from "./CommitteeMembersCreate.vue?vue&type=script&lang=js"
import style0 from "./CommitteeMembersCreate.vue?vue&type=style&index=0&id=6ed33b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports